import React from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap';

function Header() {
  return (
    <div>
       {/* Header */}
       <header className="app-header">
        <Container>
          <Row className="align-items-center text-center">
            <Col>
              <h1>Quantum-Energy Nexus</h1>
              <p className="lead">AI-Driven Quantum Network Models for Optimizing Renewable Energy</p>
            </Col>
            <Col xs="auto">
              <Button variant="outline-light">Careers</Button>
            </Col>
          </Row>
        </Container>
      </header>
    </div>
  )
}

export default Header;
